import { useMemo } from 'react';
import { ReadOnlyURLSearchParams } from './ReadOnlyURLSearchParams';
import { HistoryContext, PathnameContext, SearchParamsContext } from './routingContexts';

/**
 * Mounts Quartz's granular routing contexts (history / pathname / search
 * params) from the current location, so the quartz-routing hooks work anywhere
 * a <Router> is rendered. <Router> renders this with its current history and
 * location.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function RoutingContextBridge({
  history,
  location,
  children
}) {
  const searchParams = useMemo(() => {
    return new ReadOnlyURLSearchParams(location.search);
  }, [location.search]);
  return /*#__PURE__*/_jsx(HistoryContext.Provider, {
    value: history,
    children: /*#__PURE__*/_jsx(SearchParamsContext.Provider, {
      value: searchParams,
      children: /*#__PURE__*/_jsx(PathnameContext.Provider, {
        value: location.pathname,
        children: children
      })
    })
  });
}